import React, { useState } from 'react';
import styled from 'styled-components';
import {
  IconButton,
  Option,
  Options,
  Popover,
} from '@alefeducation/ui-elements-library-core';
import { EllipsisV } from '@alefeducation/ui-elements-library-icons';
import { DELETE_MEMBERSHIP_TEXT } from '../../utils/constants';

interface ActionIconProps {
  onDeleteClick: () => void;
  memberId: Number;
  hasAssignPermission: boolean;
}

const StyledOption = styled(Option)`
  text-align: left;
`;

export const MemberActions: React.FC<ActionIconProps> = ({
  onDeleteClick,
  memberId,
  hasAssignPermission,
}) => {
  const [open, setOpen] = useState(false);
  const [containerRef, setRef] = useState<HTMLSpanElement | null>(null);

  const deleteMembershipOption = () => (
    <StyledOption
      key={`delete-membership-button-${memberId}`}
      onClick={onDeleteClick}
    >
      {DELETE_MEMBERSHIP_TEXT}
    </StyledOption>
  );

  return (
    <span
      onClick={(e: any) => {
        e.stopPropagation();
        setOpen(!open);
      }}
      data-testid="actions-icon-container"
      ref={setRef}
    >
      <IconButton
        tooltipContent={'Actions'}
        area-label="members-actions"
        onClick={() => {}}
      >
        <EllipsisV />
      </IconButton>
      {containerRef && (
        <Popover
          anchorRef={containerRef}
          isOpen={open}
          popoverPosition="left-start"
        >
          <Options>
            <></>
            {hasAssignPermission ? (
              deleteMembershipOption()
            ) : (
              <React.Fragment />
            )}
          </Options>
        </Popover>
      )}
    </span>
  );
};
